module.exports = __webpack_public_path__ + "img/advantage-item01.84fe9989.png";